export const siteUrlBuilder = (tenantId: string, siteId: string) : string => {
    return `/${tenantId}/sites/${siteId}`;
}

export const siteMapUrlBuilder = (tenantId: string, siteId: string, featureId: string | null) : string => {
    return `/${tenantId}/sites/${siteId}/map${featureId ? `?featureId=${featureId}` : ""}`;
}

export const siteAdminUrlBuilder = (tenantId: string, siteId: string) : string => {
    return `/${tenantId}/sites/${siteId}/admin`;
}

export const actionEditUrlBuilder = (tenantId: string, siteId: string, actionId: string) : string => {
    return `/${tenantId}/sites/${siteId}/tasks/${actionId}`;
}

export const featureUrlBuilder = (tenantId: string, siteId: string, featureId: string) : string => {
    return `/${tenantId}/sites/${siteId}/features/${featureId}`;
}

export const areaCreateUrlBuilder = (tenantId: string, siteId: string) : string => {
    return `/${tenantId}/sites/${siteId}/area/create`;
}

export const siteActionsUrlBuilder = (tenantId: string, siteId: string) : string => {
    return `/${tenantId}/sites/${siteId}/tasks`;
}

export const siteObservationsUrlBuilder = (tenantId: string, siteId: string) : string => {
    return `/${tenantId}/sites/${siteId}/observations`;
}

export const areaUrlBuilder = (tenantId: string, siteId: string) : string => {
    return `/${tenantId}/sites/${siteId}/area`;
}

export const areaIndexUrlBuilder = (tenantId: string, siteId: string, areaId: string) : string => {
    return `/${tenantId}/sites/${siteId}/area/${areaId}`;
}

export const areaCourseFeatureUrlBuilder = (tenantId: string, siteId: string, areaId: string) : string => {
    return `/${tenantId}/sites/${siteId}/area/${areaId}/coursefeature`;
}

export const areaCourseObservationsUrlBuilder = (tenantId: string, siteId: string, areaId: string) : string => {
    return `/${tenantId}/sites/${siteId}/area/${areaId}/courseobservations`;
}

export const areaHabitatFeatureUrlBuilder = (tenantId: string, siteId: string, areaId: string) : string => {
    return `/${tenantId}/sites/${siteId}/area/${areaId}/habitatfeature`;
}

export const areaHabitatObservationsUrlBuilder = (tenantId: string, siteId: string, areaId: string) : string => {
    return `/${tenantId}/sites/${siteId}/area/${areaId}/habitatobservations`;
}

export const areaTasksUrlBuilder = (tenantId: string, siteId: string, areaId: string) : string => {
    return `/${tenantId}/sites/${siteId}/area/${areaId}/tasks`;
}

export const areaObservationsUrlBuilder = (tenantId: string, siteId: string, areaId: string) : string => {
    return `/${tenantId}/sites/${siteId}/area/${areaId}/observations`;
}

export const observationUrlBuilder = (tenantId: string, siteId: string, observationId: string) : string => {
    return `/${tenantId}/sites/${siteId}/observations/${observationId}`;
}

export const courseUrlBuilder = (tenantId: string, siteId: string) : string => {
    return `/${tenantId}/sites/${siteId}/course`;
}

export const featureTypeCreateUrlBuilder = (tenantId: string, siteId: string) : string => {
    return `/${tenantId}/sites/${siteId}/featuretypes/create`;
}

export const featureTypeEditUrlBuilder = (tenantId: string, siteId: string, featureTypeId: string) : string => {
    return `/${tenantId}/sites/${siteId}/featuretypes/${featureTypeId}`;
}

export const featureTypeFeatureListUrlBuilder = (tenantId: string, siteId: string, featureTypeId: string) : string => {
    return `/${tenantId}/sites/${siteId}/featuretypes/${featureTypeId}/features`;
}

export const featureTypeActionListUrlBuilder = (tenantId: string, siteId: string, featureTypeId: string) : string => {
    return `/${tenantId}/sites/${siteId}/featuretypes/${featureTypeId}/tasks`;
}

export const featureTypeUrlBuilder = (tenantId: string, siteId: string, featureTypeId: string) : string => {
    return `/${tenantId}/sites/${siteId}/featuretypes/${featureTypeId}`;
}

export const featureTypeObservationListUrlBuilder = (tenantId: string, siteId: string, featureTypeId: string) : string => {
    return `/${tenantId}/sites/${siteId}/featuretypes/${featureTypeId}/observations`;
}

export const featureTypeCreateActionUrlBuilder = (tenantId: string, siteId: string, featureTypeId: string) : string => {
    return `${createActionUrlBuilder(tenantId, siteId)}?featureTypeId=${featureTypeId}`;
}

export const habitatUrlBuilder = (tenantId: string, siteId: string) : string => {
    return `/${tenantId}/sites/${siteId}/habitat`;
}

export const projectUrlBuilder = (tenantId: string, siteId: string) : string => {
    return `/${tenantId}/sites/${siteId}/project`;
}

export const projectCreateUrlBuilder = (tenantId: string, siteId: string) : string => {
    return `/${tenantId}/sites/${siteId}/project/create`;
}

export const projectEditUrlBuilder = (tenantId: string, siteId: string, projectId: string) : string => {
    return `/${tenantId}/sites/${siteId}/project/${projectId}`;
}

export const projectTasksUrlBuilder = (tenantId: string, siteId: string, projectId: string) : string => {
    return `/${tenantId}/sites/${siteId}/project/${projectId}/tasks`;
}

export const projectCreateActionUrlBuilder = (tenantId: string, siteId: string, projectId: string) : string => {
    return `${createActionUrlBuilder(tenantId, siteId)}?projectid=${projectId}`;
}

export const featureCreateActionUrlBuilder = (tenantId: string, siteId: string, featureId: string) : string => {
    return `${createActionUrlBuilder(tenantId, siteId)}?featureId=${featureId}`;
}

export const siteCreateActionUrlBuilder = (tenantId: string, siteId: string) : string => {
    return createActionUrlBuilder(tenantId, siteId);
}

export const featureObservationsUrlBuilder = (tenantId: string, siteId: string, featureId: string) : string => {
    return `/${tenantId}/sites/${siteId}/features/${featureId}/observations`;
}

export const featureCreateObservationUrlBuilder = (tenantId: string, siteId: string, featureId: string) : string => {
    return `${observationCreateActionUrlBuilder(tenantId, siteId)}?featureId=${featureId}`;
}

export const featureTasksUrlBuilder = (tenantId: string, siteId: string, featureId: string) : string => {
    return `/${tenantId}/sites/${siteId}/features/${featureId}/tasks`;
}

export const profileUrlBuilder = () : string => {
    return `/profile`;
}

const createActionUrlBuilder = (tenantId: string, siteId: string) : string => {
    return `/${tenantId}/sites/${siteId}/tasks/create`;
}

const observationCreateActionUrlBuilder = (tenantId: string, siteId: string) : string => {
    return `/${tenantId}/sites/${siteId}/observations/create`;
}